import { PageId } from 'page-constants'

export const usePurchaseCancelOfferRoute = (): PageId => {
  return PageId.CANCEL_OFFER_QUESTION
}
